"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldModelTypeEnum = exports.FieldModelToJSON = exports.FieldModelFromJSONTyped = exports.FieldModelFromJSON = void 0;
const runtime_1 = require("../runtime");
function FieldModelFromJSON(json) {
    return FieldModelFromJSONTyped(json, false);
}
exports.FieldModelFromJSON = FieldModelFromJSON;
function FieldModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'label': json['label'],
        'type': json['type'],
        'min': !runtime_1.exists(json, 'min') ? undefined : json['min'],
        'max': !runtime_1.exists(json, 'max') ? undefined : json['max'],
        'value': !runtime_1.exists(json, 'value') ? undefined : json['value'],
    };
}
exports.FieldModelFromJSONTyped = FieldModelFromJSONTyped;
function FieldModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'label': value.label,
        'type': value.type,
        'min': value.min,
        'max': value.max,
        'value': value.value,
    };
}
exports.FieldModelToJSON = FieldModelToJSON;
/**
* @export
* @enum {string}
*/
var FieldModelTypeEnum;
(function (FieldModelTypeEnum) {
    FieldModelTypeEnum["Date"] = "date";
    FieldModelTypeEnum["Text"] = "text";
    FieldModelTypeEnum["List"] = "list";
    FieldModelTypeEnum["Number"] = "number";
    FieldModelTypeEnum["PastDate"] = "past_date";
    FieldModelTypeEnum["FutureDate"] = "future_date";
    FieldModelTypeEnum["ExpiredOverAYearDate"] = "expired_over_a_year_date";
})(FieldModelTypeEnum = exports.FieldModelTypeEnum || (exports.FieldModelTypeEnum = {}));
//# sourceMappingURL=FieldModel.js.map